import { render } from "./InvestmentPerformance.vue?vue&type=template&id=b3e5c014"
import script from "./InvestmentPerformance.vue?vue&type=script&lang=js"
export * from "./InvestmentPerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__